<script>
    import { Router, Route } from 'svelte-routing';
    import { onMount } from 'svelte';

    import Home from '../views/offers/HomeOffers.svelte';
    import Unlimited from '../views/offers/UnlimitedOffers.svelte';
    import Tripleplay from '../views/offers/TripleplayOffers.svelte';
    import Negocios from '../views/offers/NegociosOffers.svelte';
    import Sky from '../views/offers/SkyOffers.svelte';

    // Store
    import { store, store_init_offer } from '../Store.svelte';
    import { getInitOffer } from '../Util.svelte';

    if (!$store_init_offer.loadedOffer.offers) {
        getInitOffer(
            $store_init_offer,
            (offer) => ($store_init_offer.loadedOffer = offer)
        );
    }

    let currentHeight = 0;

    onMount(() => {
        const main = document.getElementsByTagName('main')[0];

        window.addEventListener('message', onMessage);

        const observer = new ResizeObserver(onResize);
        observer.observe(main, {
            attributes: true,
            childList: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
            window.removeEventListener('message', onMessage);
        };
    });

    function onResize(entries) {
        const newHeight = entries[0].target.scrollHeight;
        if (newHeight === currentHeight) return;

        currentHeight = newHeight;
        sendMessage('resize', currentHeight);
    }

    function onMessage(event) {
        const eventName = event.data.event;

        switch (eventName) {
            case 'ready':
                sendMessage('resize', currentHeight);
                break;
        }
    }

    function sendMessage(eventName, data) {
        window.parent.postMessage({ event: eventName, data }, '*');
    }
</script>

<main
    class="main-iframe"
    class:secondary-font={$store.requestedServices.isSky}
    class:secondary-body-bg={$store.requestedServices.isSky}
    class:isSky={$store.requestedServices.isSky}
>
    <Router url="offer">
        <Route path="/home" component={Home} />
        <Route path="/unlimited" component={Unlimited} />
        <Route path="/tripleplay" component={Tripleplay} />
        <Route path="/negocios" component={Negocios} />
        <Route paht="/sky" component={Sky} />
    </Router>
</main>
